import React from 'react';
import { List } from 'antd';
import styled from '@emotion/styled';

import { Wrapper, FileLink } from './common/styles';
import { changeOrder, getFileUrl, transformFieldGroup } from './common/helpers';

import FormValueWithDataSource from '../../../../../../../components/forms/form-render/form-review/form-value-with-data-source';
import { FormComponentType } from '../../../../../../../types/form';
import { getDefaultDataSource, isUUID } from '../../../../../../../utils/common';
import { DocumentType } from '../../../../../../../types/models/document';

export enum FAALReadOnlyFields {
  FILE_UPLOAD = 'fileUpload',
  TOTAL_GIFT_AMOUNT = 'total_gift_aid_amount',
  TOTAL_WORK_AMOUNT = 'total_work_study_amount',
  TOTAL_COST_AMOUNT = 'total_cost_of_attendance_amount',
  SOURCE_URL = 'source_url_for_total_cost_of_attendance',
  EFC_AMOUNT = 'efc_amount',
  HOUSING_STATUS = 'housing_status',
  INSTITUTION_NAME = 'institution_name',
}

interface FAALFieldsProps {
  data: any;
}

const renderFieldLabel = (label: string) => {
  if (!label) return null;
  switch (label) {
    case FAALReadOnlyFields.FILE_UPLOAD:
      return 'Upload from Financial Aid Award Letter (FAAL)';
    case FAALReadOnlyFields.TOTAL_GIFT_AMOUNT:
      return 'Total Gift Aid Amount';
    case FAALReadOnlyFields.TOTAL_WORK_AMOUNT:
      return 'Total Work Study Amount';
    case FAALReadOnlyFields.TOTAL_COST_AMOUNT:
      return 'Total Cost of Attendance Amount';
    case FAALReadOnlyFields.SOURCE_URL:
      return 'Source URL for Total Cost of Attendance';
    case FAALReadOnlyFields.EFC_AMOUNT:
      return 'EFC Amount';
    case FAALReadOnlyFields.HOUSING_STATUS:
      return 'Housing Status';
    case FAALReadOnlyFields.INSTITUTION_NAME:
      return 'Institution name:';
    default:
      return null;
  }
};

const renderFieldValue = (type: string, value: any) => {
  if (!value && value !== 0) {
    return null;
  }
  switch (type) {
    case FAALReadOnlyFields.FILE_UPLOAD:
      return value.map((item: any, index: number) => (
        <FileLink key={index} onClick={() => getFileUrl(item.id)}>
          {item.fileName}
        </FileLink>
      ));
    default:
      return value;
  }
};

const StyledListItem = styled(List.Item)`
  .ant-col {
    padding: 0 !important;
    font-size: 14px !important;
  }
`;

const FAALFields = (props: FAALFieldsProps) => {
  props.data.fields = changeOrder(props.data.fields);
  const transformedFields = props.data && transformFieldGroup(props.data.fields);
  const institutionDataSource = getDefaultDataSource(DocumentType.FINANCIAL_AID_AWARD_LETTER);
  return (
    transformedFields && (
      <Wrapper>
        <List
          itemLayout="horizontal"
          dataSource={transformedFields}
          renderItem={(item: { label: string; value: any }) => {
            if (item.label === FAALReadOnlyFields.INSTITUTION_NAME && isUUID(item.value)) {
              return (
                <>
                  <StyledListItem>
                    <List.Item.Meta
                      title={renderFieldLabel(item.label)}
                      description={
                        <FormValueWithDataSource
                          type={FormComponentType.AutoComplete}
                          dataSource={institutionDataSource}
                        >
                          {item.value}
                        </FormValueWithDataSource>
                      }
                    />
                  </StyledListItem>
                </>
              );
            }
            return (
              <List.Item>
                <List.Item.Meta
                  title={renderFieldLabel(item.label)}
                  description={item.label !== 'documentType' ? renderFieldValue(item.label, item.value) : ''}
                />
              </List.Item>
            );
          }}
        />
      </Wrapper>
    )
  );
};

export default FAALFields;
